import FastCompany from '@/components/icons/FastCompany'
import Huffington from '@/components/icons/Huffington'
import Entrepreneur from '@/components/icons/Entrepreneur'
import Independent from '@/components/icons/Independent'
import Trends from '@/components/icons/Trends'
import Inc from '@/components/icons/Inc'
import Forbes from '@/components/icons/Forbes'
import { EndlessCarousel } from '@/components/carousel/EndlessCarousel'

export function RecommendedIn() {
  return (
    <div className='mb-[40px] xl:mb-[80px]'>
      <span className='text-[18px] font--primary italic text-white/70 xl:mb-[20px] block'>Recommended in:</span>
      <EndlessCarousel
        delayStart={600}
        className="logos-carousel !w-[100%]"
        slides={[
          {
            content: <div className="mr-[40px] w-[100px] h-[65px]"><Forbes style={{height: '65px'}} responsive={true}/></div>
          },
          {
            content: <div className="mr-[40px] mt-[5px] w-[150px] h-[60px]"><Entrepreneur style={{height: '60px'}} responsive={true}/></div>
          },
          {
            content: <div className="mr-[40px] mt-[5px] w-[150px] h-[60px]"><Huffington style={{height: '60px'}} responsive={true}/></div>
          },
          {
            content: <div className="mr-[40px] mt-[2px] w-[155px] h-[60px]"><FastCompany style={{height: '60px'}} responsive={true}/></div>
          },
          {
            content: <div className="mr-[40px] w-[180px] h-[65px]"><Independent style={{height: '65px'}} responsive={true}/></div>
          },
          {
            content: <div className="mr-[40px] w-[120px] h-[60px]"><Trends style={{height: '60px'}} responsive={true}/></div>
          },
          {
            content: <div className="mr-[40px] w-[80px] h-[60px]"><Inc style={{height: '60px'}} responsive={true}/></div>
          },
        ]}
      />
    </div>
  )
}
